import {CreditDetailsResponse} from "@/types/service-response";
import {formatFloatPrice} from '@/services/formatter';

export class CreditDetails {
  private constructor (
    readonly id: number,
    readonly createdAt: string,
    readonly kind: string,
    readonly amount: number,
    readonly description: string

  ) {}

  get formattedAmount(): string {
    return formatFloatPrice(this.amount)
  }

  static createFromResponse (responseData: CreditDetailsResponse[]): CreditDetails[] {
    return responseData.map((item: CreditDetailsResponse) => {
      return new CreditDetails(
        item.id,
        item.createdAt,
        item.kind,
        item.amount,
        item.description,
      )
    })
  }
}
